import Paragraph from "./Paragraph";

function Article(props) {
	const {
		openedAccordions,
		setOpenedAccordions,
		sections,
		deprecatedArticleId,
		paragraphClassName,
	} = props;

	const renderSections = () => {
		return sections.map((section, id) => (
			<Paragraph
				className={paragraphClassName}
				key={section.id}
				section={section}
				openedAccordions={openedAccordions}
				setOpenedAccordions={setOpenedAccordions}
				deprecatedArticleId={deprecatedArticleId}
				index={id}
			/>
		));
	};

	return (
		<article className="flex flex-col gap-8 flex-1">{renderSections()}</article>
	);
}

export default Article;
